import Vue from 'vue'
import Vuex from 'vuex'
import User from "./modules/user/index"
import Subject from "./modules/subject/index"
import Classes from "./modules/classes/index"
import SnakeBar from "./modules/snakeBar/index"
import Permission from "./modules/permissions/index"
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        User,
        Subject,
        Classes,
        SnakeBar,
        Permission
    },
    strict: process.env.DEV
})